import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { TriggerManualSyncParams } from '../types';
import { SyncLogsApi, type SyncLogsApiContract } from './logs.api';

export interface SyncApiContract {
  triggerManualSync(params: TriggerManualSyncParams): Promise<void>;
  logs(): SyncLogsApiContract;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    sync: SyncApiContract;
  }
}

export class SyncApi extends ApiService implements SyncApiContract {
  triggerManualSync({ teamSlug, environment, dataType }: TriggerManualSyncParams): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `/${teamSlug}/${environment}/ignite/sync/${dataType}`,
    });
  }

  logs(): SyncLogsApiContract {
    return new SyncLogsApi(this.api);
  }
}
